(function () {
    const $input   = $('#input-reading-item-v2');
    const $results = $('#reading-results');
    const $hidden  = $('#selected-book-codigo');
    const $spinner = $('#reading-spinner');
    const $uuid    = $('#transfer_uuid');

    let debounceTimer = null;

    function setHidden(codigo) {
        $hidden.val(codigo ?? '');
    }

    function reset() {
        setHidden(null);
        $input.val('');
        $results.empty();
        $input.focus();
    }

    function renderSelected(item) {
        $results.html(`
            <div class="alert alert-success d-flex justify-content-between align-items-center py-2 mt-1 mb-0">
                <div>
                    <strong>${item.descripcion}</strong>
                    <small class="d-block text-muted">${item.codigo}</small>
                </div>
                <button type="button" class="btn btn-sm btn-outline-secondary ml-2" id="btn-clear-book">
                    Cambiar
                </button>
            </div>
        `);
        $('#btn-clear-book').on('click', reset);
    }

    function renderDropdown(items) {
        const listItems = items.map(item => `
            <a href="#"
               class="list-group-item list-group-item-action py-2"
               data-codigo="${item.codigo}"
               data-descripcion="${item.descripcion}">
                <strong>${item.descripcion}</strong>
                <small class="d-block text-muted">${item.codigo}</small>
            </a>
        `).join('');

        $results.html(`
            <div class="list-group mt-1 shadow-sm" id="book-dropdown">
                ${listItems}
            </div>
        `);

        $('#book-dropdown').on('click', '.list-group-item', function (e) {
            e.preventDefault();
            const item = {
                codigo:      $(this).data('codigo'),
                descripcion: $(this).data('descripcion')
            };
            setHidden(item.codigo);
            $input.val(item.descripcion);
            renderSelected(item);
        });
    }

    function renderEmpty(q) {
        $results.html(`
            <div class="list-group mt-1">
                <span class="list-group-item text-muted py-2">
                    Sin resultados para "<em>${q}</em>"
                </span>
            </div>
        `);
    }

    function search(q) {
        $spinner.removeClass('d-none');
        $results.empty();

        let data = new FormData();
        data.append('q', q);
        data.append('uuid', $uuid.val());

        $.ajax({
            url: '/libros.buscar',
            method: 'POST',
            data: data,
            processData: false,
            contentType: false,
            headers: {
                'X-CSRF-TOKEN': $('meta[name="csrf-token"]').attr('content')
            },
            success: function (response) {

                if (response.success === true) {
                    //document.getElementById('div-table-detail-transfer-v2').innerHTML = response.view;
                    location.reload();
                    alertSuccess(response.msg);
                    reset();
                    return;

                }

                if (response.success === false) {
                    alertError(response.msg);
                    return;
                }

                const items = response.result;

                if (!items || items.length === 0) {
                    renderEmpty(q);
                } else if (items.length === 1) {
                    setHidden(items[0].codigo);
                    $input.val(items[0].descripcion);
                    renderSelected(items[0]);
                } else {
                    renderDropdown(items);
                }
            },
            error: function (xhr) {
                const errores = xhr.responseJSON?.errors;
                $results.html(`
                    <div class="alert alert-danger py-2 mt-1 mb-0">
                        ${errores
                    ? Object.values(errores).flat().join('<br>')
                    : 'Error al buscar. Intenta de nuevo.'}</div>
                `);
            },
            complete: function () {
                $spinner.addClass('d-none');
            }
        });
    }

    $input.on('input', function () {
        clearTimeout(debounceTimer);
        setHidden(null);
        const q = $(this).val().trim();

        if (q.length < 2) {
            $results.empty();
            return;
        }

        debounceTimer = setTimeout(() => search(q), 350);
    });

})();
